var map = {
	"./18plus-black.svg": 8857,
	"./18plus.svg": 4684,
	"./be-gamble-aware.svg": 8260,
	"./gambling-therapy.svg": 4826,
	"./gamcare.svg": 6979,
	"./gamstop.svg": 8624,
	"./raig.svg": 1272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8006;